@if(deleteClaim) {
    <div class="my-3 mx-1">
        <h1 mat-dialog-title class="sub-header-title">Delete Claim  #{{ this.claim.id }}</h1>
        <div mat-dialog-content class="my-3">
            <div>Please confirm you would like to delete this Claim?</div>
        </div>
        <div mat-dialog-actions class="justify-content-end">
            <button mat-raised-button class="cancel-button" (click)="onCancelClick()">
                Cancel
            </button>
            <button mat-raised-button class="warn-button" (click)="onDeleteClick()">
                Delete
            </button>
        </div>
    </div>
}

@if(!deleteClaim) {
    <div class="my-3 mx-3">
        <h1 mat-dialog-title class="sub-header-title">Undelete Claim  #{{ this.claim.id }}</h1>
        <div mat-dialog-content class="my-3">
            <div class="row mt-3 mb-2 mx-2 justify-content-between">
                <div class="col-auto d-flex flex-column">
                    <app-detail-info-card class="col-12" [data]="claimDetails" [title]="'Claim Details'"></app-detail-info-card>
                </div>
            </div>
        </div>
        <div mat-dialog-actions class="justify-content-end">
            <button mat-raised-button class="cancel-button" (click)="onCancelClick()">
                Cancel
            </button>
            <button mat-raised-button class="action-button" (click)="onUndeleteClick()">
                Undelete
            </button>
        </div>
    </div>
}